import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { EAuthActions } from '@myStore/auth/auth.actions';
import { CoursesChangesEffects } from '@myStore/courses-changes/courses-changes.effects';
import { CoursesViewEffects } from '@myStore/courses-view/courses-view.effects';
import { ESDPChangesEffects } from '@myStore/ESDP-changes/ESDP-changes.effects';
import { ESDPViewEffects } from '@myStore/ESDP-view/ESDP-view.effects';
import { EventsChangesEffects } from '@myStore/events-changes/events-changes.effects';
import { EventsViewEffects } from '@myStore/events-view/events-view.effects';
import { GroupsChangesEffects } from '@myStore/groups-changes/groups-changes.effects';
import { GroupsViewEffects } from '@myStore/groups-view/groups-view.effects';
import { PeriodsChangesEffects } from '@myStore/periods-changes/periods-changes.effects';
import { PeriodsViewEffects } from '@myStore/periods-view/periods-view.effects';
import { ProfileChangesEffects } from '@myStore/profile-changes/profile-changes.effects';
import { ProfileViewEffects } from '@myStore/profile-view/profile-view.effects';
import { ProfileEffects } from '@myStore/profile/profile.effects';
import { SalesChangesEffects } from '@myStore/sales-changes/sales-changes.effects';
import { SalesViewEffects } from '@myStore/sales-view/sales-view.effects';
import { StudentResultsViewEffects } from '@myStore/student-results-view/student-results-view.effects';
import { StudentsPerformanceEffects } from '@myStore/students-performance/studetns-performance.effects';
import { ThemeEffects } from '@myStore/theme/theme.effects';
import { UsersChangesEffects } from '@myStore/users-changes/users-changes.effects';
import { UsersViewEffects } from '@myStore/users-view/users-view.effects';
import { WorkDebtorsEffects } from '@myStore/work-debtors/work-debtors.effects';
import { EffectsModule } from '@ngrx/effects';
import { StoreRouterConnectingModule } from '@ngrx/router-store';
import { ActionReducer, MetaReducer, StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { environment } from '../../environments/environment';
import { AuthInterceptor } from './interceptors/auth/auth.interceptor';
import { GlobalHttpInterceptorService } from './interceptors/http/http.intercepter';
import { appReducers } from './store/app.reducers';
import { AuthEffects } from './store/auth/auth.effects';
import { CoursesEffects } from './store/courses/courses.effects';
import { EventsEffects } from './store/events/events.effects';
import { GroupsEffects } from './store/groups/groups.effects';
import { MailingsEffects } from './store/mailings/mailings.effects';
import { MaterialsEffects } from './store/materials/materials.effects';
import { NotificationsEffects } from './store/notifications/notifications.effects';
import { StudentWorksEffects } from './store/student-works/student-works.effects';
import { UserEffects } from './store/users/user.effects';
import { AccountantsViewEffects } from '@myStore/accountants/view/accountants-view.effects';
import { CompaniesViewEffects } from '@myStore/companies/view/companies-view.effects';
import { CompaniesChangesEffects } from '@myStore/companies/changes/companies-changes.effects';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function debug(reducer: ActionReducer<any>): ActionReducer<any> {
  return function (state, action) {
    switch (action.type) {
      case EAuthActions.LogoutSuccess:
        state = undefined;
    }

    return reducer(state, action);
  };
}

export const metaReducers: MetaReducer[] = [debug];

@NgModule({
  declarations: [],
  imports: [
    HttpClientModule,
    StoreModule.forRoot(appReducers, { metaReducers }),
    EffectsModule.forRoot([
      UserEffects,
      AuthEffects,
      CoursesEffects,
      GroupsEffects,
      NotificationsEffects,
      EventsEffects,
      MaterialsEffects,
      ProfileEffects,
      StudentWorksEffects,
      ThemeEffects,
      MailingsEffects,
      CoursesViewEffects,
      CoursesChangesEffects,
      GroupsViewEffects,
      GroupsChangesEffects,
      UsersViewEffects,
      UsersChangesEffects,
      PeriodsViewEffects,
      PeriodsChangesEffects,
      StudentsPerformanceEffects,
      EventsViewEffects,
      EventsChangesEffects,
      StudentResultsViewEffects,
      ProfileViewEffects,
      ProfileChangesEffects,
      WorkDebtorsEffects,
      ESDPViewEffects,
      ESDPChangesEffects,
      SalesViewEffects,
      SalesChangesEffects,
      AccountantsViewEffects,
      CompaniesViewEffects,
      CompaniesChangesEffects,
    ]),
    StoreRouterConnectingModule.forRoot({ stateKey: 'router' }),
    !environment.production ? StoreDevtoolsModule.instrument() : [],
    CommonModule,
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: GlobalHttpInterceptorService,
      multi: true,
    },
  ],
})
export class CoreModule {}
